import { api } from '../services/api'
import {
  REGISTRATION_PENDING,
  REGISTRATION_SUCCESS,
  REGISTRATION_FAIL,
  CLEAR_REGISTRATION_ERROR,
} from '../actions/index'

const initialState = {
  email: null,
  firstName: null,
  lastName: null,
  UID: null,
  error: '',
  loading: false,
  newsletter: false,
}

export default function registration(state = initialState, action) {
  switch (action.type) {
    case REGISTRATION_PENDING: {
      return {
        ...state,
        email: null,
        firstName: null,
        lastName: null,
        UID: null,
        error: '',
        loading: true,
        newsletter: false,
      }
    }

    case REGISTRATION_SUCCESS: {
      const { email, firstName, lastName, UID, newsletter } = action.payload

      return {
        ...state,
        email: email,
        firstName: firstName,
        lastName: lastName,
        UID: UID,
        error: '',
        loading: false,
        newsletter: newsletter,
      }
    }

    case REGISTRATION_FAIL: {
      return {
        ...state,
        error: api.stringifyResponseErrors(action.payload.data),
        loading: false,
      }
    }

    case CLEAR_REGISTRATION_ERROR: {
      return {
        ...state,
        error: '',
        loading: false,
      }
    }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/registration.js